<template>
  <i-container class="content">
    <div :class="{ 'flex-container': isBigScreen, 'flex-column': !isBigScreen }">
      <i-form :schema="form" @keyup.enter="filter" :class="{ 'element1b': isBigScreen, 'element1s': !isBigScreen }">
        <i-form-group>
          <i-input :schema="form.cospar" v-model="form.cospar.value" placeholder="COSPAR or name" @keyup.enter="filter"></i-input>
        </i-form-group>

        <i-form-group>
          <i-input :schema="form.norad" v-model="form.norad.value" placeholder="NORAD"></i-input>
        </i-form-group>

        <i-form-group id="minam">
          <i-input :schema="form.minam" v-model="form.minam.value" placeholder="Minimal absolute magnitude"></i-input>
        </i-form-group>

        <i-form-group id="maxam">
          <i-input :schema="form.maxam" v-model="form.maxam.value" placeholder="Maximal absolute magnitude"></i-input>
        </i-form-group>

        <i-form-group id="button-form-group" class="_clearfix">
          <i-button type="submit" class="_margin-left-1-2 _float-right" outline variant="primary" @click="filter">Filter</i-button>
          <i-button class="_float-right" outline variant="danger" @click="clearFilter">Clear filter</i-button>
          <i-button class="_float-left" outline variant="info" @click="visible = true">Help</i-button>

<!--          <p class="_float-left _width-65 _text-left _font-size-sm _margin-0 _padding-0 _padding-left-1-->
<!--                      _display-xs-none _display-sm-none _display-md-none _display-lg-block">-->
<!--            <strong>Citation</strong>: If the available data are used in any scientific or academic-->
<!--            publications, this work should be properly cited and acknowledged.  Please, use the-->
<!--            <a href="https://www.sciencedirect.com/science/article/pii/S0273117720300727">following reference to cite the work</a>.-->
<!--          </p>-->
        </i-form-group>
      </i-form>
      <i-table striped responsive :class="{ 'element2b': isBigScreen, 'element2s': !isBigScreen }">
        <tbody>
          <tr v-for="row in table">
            <td class="custom-table-left">{{ row.colname }}</td>
            <td class="custom-table-right">{{ row.colvalue }}</td>
          </tr>
        </tbody>
      </i-table>
    </div>
    <i-modal id="help-modal" variant="info" v-model="visible" size="lg">
            <template slot="header">Help</template>
            <div class="row">
                <h4 class="column _margin-top-0">Phase curve properties</h4>
            </div>
            <dl class="row">
                <dt class="column -xs-3">Source</dt>
                <dd class="column -xs-9">json file containing the phase curve data.</dd>

                <dt class="column -xs-3">Data source</dt>
                <dd class="column -xs-9">source catalogue of the used photometric data</dd>

                <dt class="column -xs-3">H [mag]</dt>
                <dd class="column -xs-9">absolute magnitude</dd>

                <dt class="column -xs-3">H error [mag]</dt>
                <dd class="column -xs-9">absolute magnitude error</dd>

                <dt class="column -xs-3">Pb [mag]</dt>
                <dd class="column -xs-9">prediction band</dd>

                <dt class="column -xs-3">Aρ [m<sup>2</sup>]</dt>
                <dd class="column -xs-9">mean cross section multiplied by geometric albedo</dd>

                <dt class="column -xs-3">Aρ error [m<sup>2</sup>]</dt>
                <dd class="column -xs-9"> mean cross section multiplied by geometric albedo error</dd>

                <dt class="column -xs-3">Beta [-]</dt>
                <dd class="column -xs-9">beta parameter</dd>

                <dt class="column -xs-3">Beta error [-]</dt>
                <dd class="column -xs-9">beta parameter error</dd>

                <dt class="column -xs-3">Number of points</dt>
                <dd class="column -xs-9">Number of measurement points in the light curve.</dd>

                <dt class="column -xs-3">MJD last</dt>
                <dd class="column -xs-9">MJD of the latest measurement used for the analysis</dd>

            </dl>

            <div class="row">
                <h4 class="column _margin-top-1">Object and orbital properties</h4>
            </div>
            <dl class="row">
                <dt class="column -xs-3">Object name</dt>
                <dd class="column -xs-9">Name of the object as published in USSTRATCOM satellite situation report (SSR).</dd>

                <dt class="column -xs-3">Object type</dt>
                <dd class="column -xs-9">Type of the object as published in USSTRATCOM SSR.</dd>

                <dt class="column -xs-3">NORAD</dt>
                <dd class="column -xs-9">NORAD number of the object.</dd>

                <dt class="column -xs-3">Orbital period [min]</dt>
                <dd class="column -xs-9">Orbital period as published in USSTRATCOM SSR.</dd>

                <dt class="column -xs-3">Inclination [deg]</dt>
                <dd class="column -xs-9">Orbital inclination as published in USSTRATCOM SSR.</dd>

                <dt class="column -xs-3">Perigee [km]</dt>
                <dd class="column -xs-9">Mean perigee altitude above the Earth surface as published in USSTRATCOM SSR.</dd>

                <dt class="column -xs-3">Apogee [km]</dt>
                <dd class="column -xs-9">Mean apogee altitude above the Earth surface as published in USSTRATCOM SSR.</dd>

                <dt class="column -xs-3">Decayed</dt>
                <dd class="column -xs-9">Information whether the object is already decayed as published in USSTRATCOM SSR.</dd>
            </dl>
<!--            <div class="row">-->
<!--                <h4 class="column _margin-top-1">References</h4>-->
<!--            </div>-->

<!--            <div class="row">-->
<!--                <div class="column -xs-12 _margin-bottom-1 _font-size-sm">-->
<!--                    M. Hamara. Rotation properties of the articial objects in the vicinity of Earth, Dissertation thesis. PhD thesis, Comenius University in Bratislava; Faculty of Mathematics, Physics and Informatics Bratislava, 2017.-->
<!--                </div>-->
<!--                <div class="column -xs-12 _font-size-sm">-->
<!--                    M.H. Montgomery and D O’Donoghue. A derivation of the errors for least squares fitting to time series data. Delta Scuti Star Newsletter, 13:28, 1999.-->
<!--                </div>-->
<!--            </div>-->
            <template slot="footer">
                <div>
                    If you have further question, don't hesitate to contact us at <a href="mailto:jiri.silha@fmph.uniba.sk">jiri.silha@fmph.uniba.sk</a>.
                </div>
                <div>
                  link to database in json format: <a href='/static/data/database.json'>database</a>
                </div>
            </template>
        </i-modal>
  </i-container>
</template>

<script>
    export default {
        name: "LCDForm",
        data() {
            return {
                visible: false,
                isBigScreen: window.innerWidth > 600,
                table: [
                  {colname: "objects", colvalue: "605"},
                  {colname: "spacecrafts", colvalue: "191"},
                  {colname: "rocket bodies", colvalue: "314"},
                  {colname: "debris", colvalue: "100"}
                    ],
                form: this.$form({
                    cospar: {
                        value: ''
                    },
                    norad: {
                        value: '',
                        validateOn: 'input',
                        validators: [
                            {
                                rule: 'custom',
                                validator: function (v) {
                                    if (v.length === 0) return true;
                                    return /^\d+$/i.test(v);
                                },
                                message: 'Please enter only numbers or keep this field empty.'
                            }
                        ]
                    },
                    minam: {
                        value: '',
                        validateOn: 'input',
                        validators: [
                            {
                                rule: 'custom',
                                validator: function (v) {
                                    if (v.length === 0) return true;
                                    let valid = !/^\s*$/.test(v) && !isNaN(v);
                                    if (!valid) return false;
                                    let value = parseFloat(v);
                                    return value >= 0;
                                },
                                message: 'Please enter only positive numbers (can be decimal) or keep this field empty.'
                            }
                        ]
                    },
                    maxam: {
                        value: '',
                        validateOn: 'input',
                        validators: [
                            {
                                rule: 'custom',
                                validator: function (v) {
                                    if (v.length === 0) return true;
                                    let valid = !/^\s*$/.test(v) && !isNaN(v);
                                    if (!valid) return false;
                                    let value = parseFloat(v);
                                    return value >= 0;
                                },
                                message: 'Please enter only positive numbers (can be decimal) or keep this field empty.'
                            }
                        ]
                    }
                })
            }
        },
        methods: {
            filter (e) {
                this.$emit('filterClicked', this.$data.form);
            },
            clearFilter (e) {
                let form = this.$data.form;

                form.cospar.value = '';
                form.norad.value = '';
                form.minam.value = '';
                form.maxam.value = '';

                this.$emit('clearFilterClicked');
            },
            handleResize() {
                this.isBigScreen = window.innerWidth > 600;
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
    }
</script>

<style scoped>
    .content {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    #minam {
        margin-bottom: 0;
    }

    #maxam {
        /*margin-top: 0;*/
    }

    .test {
        border-color: #ced4db!important;
    }

    #minam >>> .form-group-error {
        /*padding-bottom: 4px;*/
    }

    .form-group+.form-group {
        margin-top: 5px;
    }

    #button-form-group {
        margin-top: 5px;
    }

    #help-modal >>> .body {
        overflow-y: auto;
        max-height: 50vh;
    }

    #help-modal >>> .body {
        max-height: calc(var(--vh, 1vh) * 50);
    }

    #date-input >>> input {
        background-color: white!important;
        cursor: pointer;
    }

    ._width-65 {
        width: 65%!important;
    }

    .custom-table-left {
      text-align: left;
    }

    .custom-table-right {
      text-align: right;
    }

    .flex-container {
      display: flex;
      width: 100%;
    }

    .flex-column {
      flex-direction: column;
      width: 100%;
    }

    .element1b {
      padding-right: 5px;
      width: calc(100% - 270px);
    }

    .element1s {
    }

    .element2b {
      padding-left: 5px;
      max-width: 280px;
    }

    .element2s {
      padding-top: 5px;
    }

    /* Add responsive styles using media queries */
    /*@media (max-width: 700px) {
      .flex-container {
        flex-direction: column;
      }
    }*/

</style>



// WEBPACK FOOTER //
// src/components/LCDForm.vue